export const DEPLOY_TOKEN_EVENT_NAME = 'deploy-token';
export const UPDATE_EVENT_NAME = 'update';
